import React, { Component } from 'react';
import './tabs.scss';
import { PropTypes } from 'prop-types';

class Tabs extends Component {
  state = {};

  selectTab = id => {
    this.setState(state => ({ ...state, selected: id }));
  };

  render() {
    const { data } = this.props;
    const { selected = data[0].id } = this.state;
    return (
      <div className="tabs">
        <section>
          {data &&
            data.length &&
            data.map(el => (
              <React.Fragment key={el.id}>
                <input
                  id={el.id}
                  type="radio"
                  checked={el.id === selected}
                  onChange={() => {}}
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                <label htmlFor={el.id} onClick={() => this.selectTab(el.id)}>
                  {el.title}
                </label>
              </React.Fragment>
            ))}
        </section>
        <div className="tabsContent">
          {data &&
            data.length &&
            data.map(el => (el.id === selected ? el.child() : null))}
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      child: PropTypes.func.isRequired
    })
  ).isRequired
};

export default Tabs;
